<template>
  <div class="product-container">
    <!--<div>
      <el-carousel height="426px" style="background-color: #409EFF;">
        <el-carousel-item v-for="(item,index1) in topImages" :key="index1">
          <el-image :src="item.url" :fit="item.fit"></el-image>
        </el-carousel-item>
      </el-carousel>
    </div>-->
    <el-image :src="topImage" :fit="fit" class="mb-10 bs-10 br-10 db" style="height: 426px;"></el-image>
    <div class="category mb-10 bs-10 br-10">
      <h2><em>Products Category</em></h2>
      <el-divider>
        <!--i class="el-icon-s-grid"></i-->
      </el-divider>
      <div class="title" style="width: 100%;">
        <el-row :gutter="10">
          <el-col :span="4" v-for="(type,index) in types" :key="index">
            <el-button @click="handleTypeClick(type)" style="width: 100%;">{{type.productType}}</el-button>
          </el-col>
          <el-col :span="4">
            <el-button @click="handleTypeClick()" style="width: 100%;">All</el-button>
          </el-col>
        </el-row>
      </div>
    </div>
    <div>
      <el-row :gutter="10">
        <el-col :span="8" v-for="(data,index3) in datas" :key="index3">
          <template v-if="data.imageList.length>0">
            <div class="image-box bs-10 br-10">
              <!--el-image :src="data.imageList[0].url" class="br-10" :fit="fit"></el-image-->
              <img :src="data.imageList[0].url" class="br-10" />
              <div class="overlay">
                <h3 style="height: 40px;">{{data.productTitle}}</h3>
                <el-button round @click="showProductDetail(data.productId)">查看详情 +</el-button>
              </div>
            </div>
          </template>
        </el-col>
      </el-row>
    </div>
    <div class="h-60"></div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        typeId: '',
        topImage: '',
        fit: 'fit',
        datas: {},
        types: {},
      }
    },
    methods: {
      showProductDetail(id) {
        //this.$router.push('/product-detail/' + id);
        this.$router.push({
          name: 'ProductDetail',
          params: {
            id: id
          }
        });
      },
      getType() {
        this.$axios.get('/api/producttype').then(res => {
            console.log(res.data);
            if (res.data.code == '0') {
              this.types = res.data.data;
            } else {
              this.$message({
                message: res.data.msg,
                type: 'error'
              })
            }
          })
          .catch(function(error) { // 请求失败处理
            console.log(error);
          });
      },
      getTopImage() {
        this.$axios.get('/api/topimage/business').then(res => {
            console.log(res.data);
            if (res.data.code == '0') {
              this.topImage = res.data.data[0].url;
            } else {
              this.$message({
                message: res.data.msg,
                type: 'error'
              })
            }
          })
          .catch(function(error) { // 请求失败处理
            console.log(error);
          });
      },
      getData() {
        //debugger
        let url;
        if (this.typeId != undefined) {
          url = '/api/product/type/' + this.typeId;
        } else {
          url = '/api/product';
        }
        this.$axios.get(url).then(res => {
            console.log(res.data);
            if (res.data.code == '0') {
              this.datas = res.data.data;
            } else {
              this.$message({
                message: res.data.msg,
                type: 'error'
              })
            }
          })
          .catch(function(error) { // 请求失败处理
            console.log(error);
          });
      },
      handleTypeClick(item) {
        console.log(item);
        //this.$router.push({ name: 'ProductCategory', params: { id: item.id }});
        if (item != undefined) {
          this.typeId = item.id;
        } else {
          this.typeId = undefined;
        }
        this.getData();
      },
    },
    mounted: function() {
      console.log('mounted');
      //debugger
      this.typeId = this.$route.params.id;
      this.getData();

      this.getTopImage();
      this.getType();
    }
  }
</script>

<style scoped>
  .product-container {
    width: 1200px;
    margin: 0 auto;
    margin-top: 10px;
    margin-bottom: 50px;
    /* background: #FFFFFF; */
  }

  .category {
    background-color: #fff;
    padding: 0 10px;
    padding-top: 20px;
    padding-bottom: 20px;
    /*height: 170px;*/
  }

  .category:after {
    display: block;
    content: '';
    clear: both;
    height: 0;
    overflow: hidden
  }

  .category h2 {
    text-align: center;
  }

  .category h2 em {
    display: block;
    font-size: 20px;
    color: #cecece;
    text-transform: uppercase;
    font-weight: normal;
  }

  .category .title {
    float: left;
    background-color: #FFF;
  }

  .category .title button {
    width: 98%;
    margin-bottom: 20px;
  }

  .image-box {
    position: relative;
    height: 250px;
    /* transition: transform 1s ease; */
    /* box-shadow: 10px 10px 5px #888888; */
    margin-bottom: 10px;
    overflow: hidden;
  }

  .image-box .el-image {
    width: 100%;
    height: 100%;
    transition: transform 1s ease;
  }

  .image-box img {
    width: 100%;
    height: 100%;
    transition: transform 1s ease;
    position: absolute;
    left: 0px;
  }

  .image-box:hover img {
    transform: scale(1.2);
  }

  .image-box:hover .el-image {
    transform: scale(1.2);
  }

  .image-box:hover .overlay {
    left: 0;
  }

  .image-box .overlay {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 100%;
    color: #fff;
    text-align: center;
    line-height: 250px;
    background: rgba(0, 0, 0, 0.5);
    transition: all .5s ease;
  }
</style>



// WEBPACK FOOTER //
// src/components/ProductCategory.vue